<template>
	<div class="container-fluid">
		<div class="row">
			<div class=" col-lg-8 mr-auto ml-auto  col-md-10">
				<form class="form-horizontal" action="." method="post">
					<div class="row form-group">
						<label class="col-md-3 offset-md-2">{{ 'Group name' | translate }} *</label>
						<div class="col-md-7">
							<input :class="groupNameError ? 'error' : ''" v-model="groupName" class="form-control" />
						</div>
						<label class="col-12 text-right text-danger" v-if="groupNameError">{{ groupNameError }}</label>
					</div>
					<div class="row form-group">
						<label class="col-md-3 offset-md-2">{{ 'Group address' | translate }} *</label>
						<div class="col-md-7">
							<input :class="groupAddressError ? 'error' : ''" v-model="groupAddress" class="form-control" />
						</div>
						<label class="col-12 text-right text-danger" v-if="groupAddressError">{{ groupAddressError }}</label>
					</div>
					<!-- <div class="row form-group">
						<label class="col-md-3 offset-md-2">{{ 'District' | translate }} *</label>
						<div class="col-md-7">
							<input :class="groupDistrictError ? 'error' : ''" v-model="groupDistrict" class="form-control" />
						</div>
						<label class="col-12 text-right text-danger" v-if="groupDistrictError">{{ groupDistrictError }}</label>
					</div>
					<div class="row form-group">
						<label class="col-md-3 offset-md-2">{{ 'Location name' | translate }} *</label>
						<div class="col-md-7">
							<input :class="groupLocationError ? 'error' : ''" v-model="groupLocation" class="form-control" />
						</div>
						<label class="col-12 text-right text-danger" v-if="groupLocationError">{{ groupLocationError }}</label>
					</div>
					<div class="row form-group">
						<label class="col-md-3 offset-md-2">{{ 'Street' | translate }} *</label>
						<div class="col-md-7">
							<input :class="groupStreetError ? 'error' : ''" v-model="groupStreet" class="form-control" />
						</div>
						<label class="col-12 text-right text-danger" v-if="groupStreetError">{{ groupStreetError }}</label>
					</div> -->
					<div class="row form-group">
						<label class="col-md-3 offset-md-2">{{ 'Start of study' | translate }} *</label>
						<div class="col-md-7">
							<datepicker :class="studyStartError ? 'error' : ''" v-model="studyStart" :format="format"></datepicker>
						</div>
						<label class="col-12 text-right text-danger" v-if="studyStartError">{{ studyStartError }}</label>
					</div>
					<div class="row form-group">
						<label class="col-md-3 offset-md-2">{{ 'Start time' | translate }} *</label>
						<div class="col-md-7">
							<vue-timepicker v-model="lessonsTime" :minute-interval="5" hide-clear-button></vue-timepicker>
						</div>
					</div>
					<div class="row form-group">
						<label class="col-md-3 offset-md-2">{{ 'Working days' | translate }} *</label>
						<div class="col-md-7">
							<input type="checkbox" v-model="days" value="Mo" />
							{{ 'Mo' | translate }}
							<input type="checkbox" v-model="days" value="Tu" />
							{{ 'Tu' | translate }}
							<input type="checkbox" v-model="days" value="We" />
							{{ 'We' | translate }}
							<input type="checkbox" v-model="days" value="Th" />
							{{ 'Th' | translate }}
							<input type="checkbox" v-model="days" value="Fr" />
							{{ 'Fr' | translate }}
							<input type="checkbox" v-model="days" value="Sa" />
							{{ 'Sa' | translate }}
							<input type="checkbox" v-model="days" value="Su" />
							{{ 'Su' | translate }}
						</div>
						<label class="col-12 text-right text-danger" v-if="daysError">{{
							daysError
						}}</label>
					</div>
					<div v-if="myRole !== 'teacher'" class="row form-group">
						<label class="col-md-3 offset-md-2">{{ 'Group teacher' | translate }} *</label>
						<div class="col-md-7">
							<v-select :class="teacherError ? 'error' : ''" :on-change="changeTeacher" :options="teacherList"
								@search="onSearch"></v-select>
						</div>
						<label class="col-12 text-right text-danger" v-if="teacherError">{{
							teacherError
						}}</label>
					</div>
					<div class="row form-group">
						<label class="col-md-3 offset-md-2">{{ 'Group age' | translate }} *</label>
						<div class="col-md-7">
							<select v-model="groupAge" class="form-control">
								<option value="Junior">{{ 'Junior' | translate }}</option>
								<option value="Average">{{ 'Average' | translate }}</option>
								<option value="Older">{{ 'Older' | translate }}</option>
								<option value="class">{{ 'Class' | translate }}</option>
							</select>
						</div>
					</div>
					<div class="row form-group" v-if="groupAge === 'class'">
						<label class="col-md-3 offset-md-2">{{
							'Group age name' | translate
						}}</label>
						<div class="col-md-7">
							<input type="text" v-model="groupAgeName" class="form-control" />
						</div>
					</div>
					<div class="text-center">
						<input @click.prevent="createProfile" type="submit" :value="'Create' | translate" class="btn btn-primary" />
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import vSelect from 'vue-select'
import 'vue2-timepicker/dist/VueTimepicker.css'
import VueTimepicker from 'vue2-timepicker'

export default {
	name: 'Group',
	data() {
		return {
			groupName: '',
			groupAddress: '',

			groupStreet: '-',
			groupLocation: '-',
			groupDistrict: '-',

			myRole: this.$store.state.myProfile.role,
			days: [],
			format: 'dd/MM/yyyy',
			studyStart: null,
			lessonsTime: {
				HH: '08',
				mm: '00',
			},

			teacherList: [],
			teacher: '',

			searchTeacherQuery: null,
			searchTeacherTimer: null,

			groupAge: 'Junior',
			groupAgeName: '',
			groupNameError: '',
			groupAddressError: '',
			groupStreetError: '',
			groupLocationError: '',
			groupDistrictError: '',
			daysError: '',
			studyStartError: '',
			teacherError: '',
		}
	},
	components: {
		vSelect,
		Datepicker,
		VueTimepicker,
	},
	methods: {
		createProfile() {
			let error = false
			this.groupNameError = ''
			this.groupAddressError = ''
			this.groupStreetError = ''
			this.groupLocationError = ''
			this.groupDistrictError = ''
			this.daysError = ''
			this.studyStartError = ''
			this.teacherError = ''

			if (this.groupName === '') {
				this.groupNameError = this.$t('Field required')
				error = true
			}

			if (this.groupAddress === '') {
				this.groupAddressError = this.$t('Field required')
				error = true
			}

			// if (this.groupStreet === '') {
			// 	this.groupStreetError = this.$t('Field required')
			// 	error = true
			// }

			// if (this.groupLocation === '') {
			// 	this.groupLocationError = this.$t('Field required')
			// 	error = true
			// }

			// if (this.groupDistrict === '') {
			// 	this.groupDistrictError = this.$t('Field required')
			// 	error = true
			// }

			if (this.days.length === 0) {
				this.daysError = this.$t('Field required')
				error = true
			}

			if (this.studyStart === null) {
				this.studyStartError = this.$t('Field required')
				error = true
			}

			if (this.teacher === '') {
				this.teacherError = this.$t('Field required')
				error = true
			}

			if (error) {
				return false
			}

			let groupAge = ''
			let lessonsTime = this.lessonsTime.HH + ':' + this.lessonsTime.mm
			let lessonsStart = this.studyStart.toISOString().slice(0, 10)

			if (this.groupAge === 'class' && this.groupAgeName.length > 0) {
				groupAge = this.groupAgeName
			} else {
				groupAge = this.groupAge
			}

			this.axios({
				method: 'post',
				url: 'groups/',
				data: {
					name: this.groupName,
					address: this.groupAddress,
					teacher: this.teacher,
					lessons_starts: lessonsStart,
					lesson_time: lessonsTime,
					district: this.groupDistrict,
					street: this.groupStreet,
					location_name: this.groupLocation,
					age: groupAge,
					working_days: this.days,
				},
			}).then(data => {
				this.$router.push({
					name: 'Dashboard List',
					params: { role: 'group' },
				})
			})
		},

		changeTeacher(val) {
			this.teacher = val.value
		},

		onSearch(query) {
			console.log("Query", query)

			const timer = 400

			if (this.searchTeacherTimer) {
				clearTimeout(this.searchTeacherTimer)
			}

			this.searchTeacherTimer = setTimeout(() => {
				this.getTeachersList(query)
			}, timer)
		},

		getTeachersList(query) {
			if (this.$store.state.myProfile.role !== 'teacher') {
				this.axios({
					method: 'get',
					url: `users/users-dropdown?role=teacher&page=1&step=12&q=${query ? query : ''}`,
				}).then(response => {
					let teacherArray = response.data

					let newTeacherList = []

					for (var i = 0; i < teacherArray.length; i++) {
						let teacher = {
							value: teacherArray[i].id,
							label:
								teacherArray[i].last_name +
								' ' +
								teacherArray[i].first_name
							// +
							// ' ' +
							// teacherArray[i].middle_name,
						}

						newTeacherList.push(teacher)
					}

					this.teacherList = newTeacherList
				})
			} else {
				this.teacher = this.$store.state.myProfile.id
			}
		}
	},

	created() {
		this.getTeachersList()
	},
}
</script>

<style scoped></style>
